import { HR_ALL_MODE } from "../modes/constants";

export const NOT_SAY = "Prefer not to say";

export const CANDIDATE_PROFILE_FORM_INITIAL_VALUES = {
  isSaved: false,
  languages: [],
  pronouns: "",
  gender: "",
  ethnicity: "",
  cv: {
    url: "",
    filename: "",
  },
  roleLevel: [],
  keywords: [],
  preferencesInterested: [],
  preferencesNotInterested: [],
  keySkills: [],
  industries: [],
  name: "",
  email: "",
  currentJobTitle: "",
  bio: "",
  linkedInURL: "",
  status: "asap",
  isOpenToWork: true,
  isAvailableForInterviews: true,
  isVisibleToEmployers: true,
  mode: HR_ALL_MODE,
};

export function getCandidateFormInitialValues({ name = "", email = "" }) {
  return { ...CANDIDATE_PROFILE_FORM_INITIAL_VALUES, name, email };
}

export const DROP_DOWN_PRONOUNS_OPTIONS = [
  { key: 1, text: "He/him", value: "He/him" },
  { key: 2, text: "She/her", value: "She/her" },
  { key: 3, text: "Them/They", value: "Them/They" },
  { key: 4, text: "Prefer not to say", value: NOT_SAY },
];

export const DROP_DOWN_GENDER_OPTIONS = [
  { key: 1, text: "Female", value: "Female" },
  { key: 2, text: "Male", value: "Male" },
  { key: 3, text: "Non-binary", value: "Non-binary" },
  { key: 4, text: "Transgender", value: "Transgender" },
  { key: 5, text: "Prefer not to say", value: NOT_SAY },
];

export const DROP_DOWN_ETHNICITY_OPTIONS = [
  { key: 1, text: "Asian", value: "Asian" },
  {
    key: 2,
    text: "Black or African American",
    value: "Black or African American",
  },
  { key: 3, text: "Hispanic", value: "Hispanic" },
  { key: 4, text: "Middle Eastern", value: "Middle Eastern" },
  { key: 5, text: "White", value: "White" },
  { key: 6, text: "Multi-racial/ethnic", value: "Multi-racial/ethnic" },
  { key: 7, text: "Prefer not to say", value: NOT_SAY },
];

const INTER_ROLE_LEVEL = "intern";
const ENTRY_ROLE_LEVEL = "entry";
const JUNIOR_ROLE_LEVEL = "junior";
const MID_ROLE_LEVEL = "mid";
const SENIOR_ROLE_LEVEL = "senior";
const EXPERT_ROLE_LEVEL = "expert";

const roleLevelLookup = {
  intern: "Internships",
  entry: "Entry-level/graduate",
  junior: "Junior (1-2 years)",
  mid: "Mid-level (3-4 years)",
  senior: "Senior (5-8 years)",
  expert: "Expert (9+ years)",
};

export function getRoleLevel(level) {
  return roleLevelLookup[level] || level;
}

export const CHECKBOX_ROLE_LEVEL_OPTIONS = [
  { key: 1, text: getRoleLevel(INTER_ROLE_LEVEL), value: INTER_ROLE_LEVEL },
  { key: 2, text: getRoleLevel(ENTRY_ROLE_LEVEL), value: ENTRY_ROLE_LEVEL },
  { key: 3, text: getRoleLevel(JUNIOR_ROLE_LEVEL), value: JUNIOR_ROLE_LEVEL },
  { key: 4, text: getRoleLevel(MID_ROLE_LEVEL), value: MID_ROLE_LEVEL },
  { key: 5, text: getRoleLevel(SENIOR_ROLE_LEVEL), value: SENIOR_ROLE_LEVEL },
  { key: 6, text: getRoleLevel(EXPERT_ROLE_LEVEL), value: EXPERT_ROLE_LEVEL },
];

export const ASAP_JOB = "asap";
export const SIX_MONTHS_JOB = "sixMonths";
const RIGHT_JOB = "rightJob";
const NOT_LOOKING_JOB = "notLooking";

const startNewJobLookup = {
  asap: "As soon as possible",
  sixMonths: "Within the next 6-12 months",
  rightJob: "Will move for the right job",
  notLooking: "Not actively looking",
};

export const startNewJobLookupStatus = {
  asap: "Looking to start a new job as soon as possible",
  sixMonths: "Looking to start a new job within the next 6-12 months",
  rightJob: "Will move for the right job",
  notLooking: "Not actively looking",
};

export function getCandidateStatus(status) {
  return startNewJobLookup[status] || status;
}

export const CANDIDATE_STATUS_OPTIONS = [
  { key: 1, text: getCandidateStatus(ASAP_JOB), value: ASAP_JOB },
  { key: 2, text: getCandidateStatus(SIX_MONTHS_JOB), value: SIX_MONTHS_JOB },
  { key: 3, text: getCandidateStatus(RIGHT_JOB), value: RIGHT_JOB },
  { key: 4, text: getCandidateStatus(NOT_LOOKING_JOB), value: NOT_LOOKING_JOB },
];
